import React, { useState } from "react";
import AddPriceButton from "./AddPriceButton";
import Prices from "./Prices";
import PriceTest from "./PriceTest";
import { CenterDiv } from "../styled_components/divs";
import { Biscuit } from "../../../../utils";
import t from "../../../helpers/t";

const PricesList = (props) => {
  const { pricesOrigin, deletePriceOrigin, addPriceOrigin, pricetypes, dispatch, onSave } = props;
  const combineAblePricetypes = [1, 15, 3, 24, 2, 29, 4, 5, 7, 10, 13, 17, 16, 18, 34];
  const [newPrice, setNewPrice] = useState({
    amount: "",
    percent_from_uvp: "",
    pricetype_id: "",
    id: null,
  });
  const [showPriceTest, setShowPriceTest] = useState(false);
  const [initialized, setInitializeState] = useState(false);
  const [usedPriceTypes, setUsedPriceTypes] = useState([]);
  const [addPrice, setAddPrice] = useState(0);
  const [setted, setSetted] = useState(false);
  const [prices, setPrices] = useState({ prices: pricesOrigin });
  const [addPriceVisible, setAddPriceVisible] = useState(true);

  let gettedPrices = prices;

  const _initialize = () => {
    let usedPricetypesArray = [];
    let prcs = [];
    if (pricesOrigin !== null) {
      pricesOrigin.forEach(function (val, index) {
        if (val.pricetype_id !== 5) {
          usedPricetypesArray.push(val.pricetype_id);
        }
        val._uid = "_" + Math.random().toString(36).substr(2, 9);
        prcs.push(val);
      });
    }
    setPrices(setStateFunction(prices, prcs));
    setUsedPriceTypes(usedPricetypesArray);
    setInitializeState(true);
    setSetted(true);
  };

  if (!initialized) {
    _initialize();
  }

  const addNewPrice = () => {
    let newPrice = {
      _uid: "_" + Math.random().toString(36).substr(2, 9),
      amount: "",
      pricetype_id: 0,
    };
    let pri = prices.prices;
    pri.push(newPrice);
    setPrices(setStateFunction(prices, pri));
    setAddPrice(addPrice + 1);
  };

  const onChangePrice = (price) => {
    console.log(price);
    let newArr = [],
      used = [];
    prices.prices.forEach(function (val, key) {
      if (val._uid === price._uid) {
        val = price;
      }
      newArr.push(val);
      used.push(val.pricetype_id);
    });
    setPrices(setStateFunction(prices, newArr));
    if (price.pricetype_id !== 5 && price.pricetype_id !== 29 && price.pricetype_id !== 15) {
      setUsedPriceTypes(used);
    }
    if (
      (price.pricetype_id === 5 || price.pricetype_id === 29 || price.pricetype_id === 15) &&
      prices.prices !== [] &&
      [...prices.prices].length <= 1
    ) {
      setUsedPriceTypes([]);
    }
    addPriceOrigin(newArr);
  };

  const onChangePercentFromUVP = (e) => {
    setNewPrice({
      ...newPrice,
      percent_from_uvp: e.target.value,
    });
  };

  const addPriceToPricetariffValidFrom = () => {
    //     props.addPrice({...newPrice});
  };

  const deletePrice = (price) => {
    let filterArray = usedPriceTypes.filter((item) => item !== price.pricetype_id);
    setUsedPriceTypes(filterArray);
    if (filterArray.length < 1) {
      setAddPriceVisible(true);
    }
    let pri = prices.prices.filter((item) => item._uid !== price._uid);
    let clone = {};
    Object.assign(clone, prices.prices);
    setPrices(setStateFunction(prices, pri));
    gettedPrices = pri;
    setAddPrice(addPrice + 1);
    deletePriceOrigin(price);
  };

  function setStateFunction(state, props) {
    return { ...state, prices: (state.prices = props) };
  }
  const showDialog = () => {
    setShowPriceTest(true);
  };
  const closeDialog = () => {
    setShowPriceTest(false);
  };
  const ID = () => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
  };
  return (
    <>
      {prices.prices.length > 0 && (
        <>
          {[...prices.prices].map((price, index) => {
            return (
              <>
                <Prices
                  key={ID}
                  pricetypes={pricetypes}
                  price={price}
                  pricesCount={[...prices.prices].length}
                  setPrice={setPrices}
                  usedPriceTypes={usedPriceTypes}
                  onChangePrice={onChangePrice}
                  deletePrice={deletePrice}
                  dispatch={dispatch}
                  setUsedPriceTypes={setUsedPriceTypes}
                  setAddPriceVisible={setAddPriceVisible}
                  combineAblePricetypes={combineAblePricetypes}
                ></Prices>
              </>
            );
          })}
        </>
      )}
      <AddPriceButton
        onAddPriceClicked={addNewPrice}
        onSave={onSave}
        addPriceVisible={addPriceVisible}
      />
      {prices.prices.length > 0 && (
        <CenterDiv className="row medium-12 small-12" style={{ paddingTop: "20px" }}>
          <a
            href="#"
            id="inb-c-left-bar-add-resource"
            onClick={showDialog}
            className={"button beautify beautify-" + Biscuit.get("user.client_id")}
          >
            <i className="fi fi-info"></i>
            <span>{t("test price")}</span>
          </a>
        </CenterDiv>
      )}
      {showPriceTest && (
        <PriceTest
          dispatch={props.dispatch}
          pricetariff={props.pricetariff}
          handleCloseDialog={closeDialog}
        />
      )}
    </>
  );
};
export default PricesList;
